import PropTypes from 'prop-types'

import IconsDepartment from 'reactGarden/IconsDepartment'

import { Icon } from 'lmcv/components/Icon'
import { isLink } from 'lmcv/modules/utils'

import * as S from './styled'

function Picture ({ src, alt, icon, isActive }) {
  const getThumb = () => {
    if (isLink(src)) {
      return <S.Image src={src} alt={alt} />
    }

    if (!src) {
      return (
        <S.IconDollar>
          <Icon name="dollar_note" fill="currentColor" />
        </S.IconDollar>
      )
    }

    return (
      <S.Icon>
        <IconsDepartment name={src} />
      </S.Icon>
    )
  }

  return (
    <S.Content isActive={isActive}>
      <S.PictureIcon>
        <Icon name="share" />
      </S.PictureIcon>

      <S.Picture>
        {getThumb()}
        <S.Symbol>
          <Icon name={icon} fill="currentColor" />
        </S.Symbol>
      </S.Picture>

      <S.SubTitle>Cupom Compartilhável</S.SubTitle>
      <S.Title>{alt}</S.Title>
    </S.Content>
  )
}

Picture.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  icon: PropTypes.oneOf(['percent', 'dollar_sign']).isRequired,
  isActive: PropTypes.bool
}

export default Picture
